import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (id: number) =>
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      api(`DELETE /treatments/schedules/${id}`, { root: supportApiBase }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.templates());
      },
    }
  );
};
